<template>
  <section class="section">
    <div class="columns is-centered">
      <div class="column is-6">
        <div class="section">
          <div class="container">
            <div class="help-container" id="signed-nda">
              <div id="title">
                <div class="container">
                  <h4 class="title is-4 helvetica" style="margin-bottom: 0;">
                    {{ $t('NF3SN1') }} {{ neofintechData.userData.firstName }}
                    {{ neofintechData.userData.lastName }},
                  </h4>
                </div>
              </div>
              <div id="message" class="postScriptum">
                <div class="container">
                  <p>{{ $t('NF3SN2') }}</p>
                  <p>{{ $t('NF3SN3') }}</p>
                  <p>{{ $t('NF3SN4') }}</p>
                </div>
              </div>
              <div id="close" class="helvetica">
                <div class="container">
                  <p class="is-size-5">
                    {{ $t(`Accede a tu panel de usuario aquí:`) }}
                  </p>
                  <button
                    type="submit"
                    class="button is-primary"
                    @click="goToLogin"
                  >
                    {{ $t(`Acceder`) }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  mixins: [],
  components: {},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('onBoard', ['neofintechData'])
  },
  methods: {
    goToLogin() {
      this.$router.push({ name: 'sign-in' })
    }
  }
}
</script>

<style lang="scss">
#signed-nda.help-container {
  max-width: 450px;
  min-height: 500px;
  margin: auto;
  background: #ffffffaa;
  backdrop-filter: blur(5px);
  border: solid 2px var(--rosa-dark-eco);
  border-radius: 40px;
  overflow: hidden;
  box-shadow: 0 5px 15px #00000044;
  
  #message {
    font-size: 20px;
    background: linear-gradient(var(--rosa-eco), var(--rosa-dark-eco));
  }
}
</style>
